(function () {
  if (window.JmpusProductCard) return;

  function element(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  function cardSettings() {
    var fallback = { style: 'standard', colorScheme: 'scheme-2', saleBadgeColorScheme: 'scheme-4' };
    var settings = window.cardSettings || {};
    return {
      style: settings.style || fallback.style,
      colorScheme: settings.colorScheme || fallback.colorScheme,
      saleBadgeColorScheme: settings.saleBadgeColorScheme || fallback.saleBadgeColorScheme,
    };
  }

  function buildWishlistButton(item) {
    var wishlistButton = element('wishlist-button', 'wishlist-button');
    wishlistButton.dataset.product = JSON.stringify(item);
    return wishlistButton;
  }

  function buildBadge(item, settings) {
    var wrap = element('div', 'card__badge bottom left');
    var badge = element('span', 'badge badge--sale badge--bottom-left color-' + settings.saleBadgeColorScheme);
    badge.textContent = 'Sale' + (item.savingPercent ? ' -' + item.savingPercent + '%' : '');
    wrap.appendChild(badge);
    return wrap;
  }

  function buildPrice(item) {
    var price = element('div', item.onSale ? 'price price--on-sale' : 'price');
    var container = element('div', 'price__container');
    var priceText = (item.priceVaries ? 'From ' : '') + (item.price || '');

    if (item.onSale && item.compareAtPrice) {
      var saleWrap = element('div', 'price__sale');
      var oldPriceOuter = element('span');
      var oldPrice = element('s', 'price-item price-item--regular');
      oldPrice.textContent = item.compareAtPrice;
      oldPriceOuter.appendChild(oldPrice);
      saleWrap.appendChild(oldPriceOuter);
      var currentPrice = element('span', 'price-item price-item--sale price-item--last');
      currentPrice.textContent = priceText;
      saleWrap.appendChild(currentPrice);
      container.appendChild(saleWrap);
    } else {
      var regularWrap = element('div', 'price__regular');
      var regularPrice = element('span', 'price-item price-item--regular');
      regularPrice.textContent = priceText;
      regularWrap.appendChild(regularPrice);
      container.appendChild(regularWrap);
    }

    price.appendChild(container);
    return price;
  }

  function buildMedia(item, settings) {
    // Dawn hides the badge in the *outer* card__content when the card has media
    // (component-card.css: `.card--{card,standard}.card--media > .card__content
    // .card__badge { display: none; }`) — the visible copy for a media card lives
    // in here instead, inside card__inner's own nested card__content.
    var inner = element(
      'div',
      'card__inner ratio' + (settings.style === 'standard' ? ' color-' + settings.colorScheme + ' gradient' : '')
    );
    inner.style.setProperty('--ratio-percent', '100%');

    var media = element('div', 'card__media');
    var mediaInner = element('div', 'media media--transparent');
    var image = element('img', 'motion-reduce');
    image.src = item.image;
    image.alt = item.title || '';
    image.loading = 'lazy';
    mediaInner.appendChild(image);
    media.appendChild(mediaInner);
    inner.appendChild(media);

    var innerContent = element('div', 'card__content');
    var innerInformation = element('div', 'card__information');
    var innerHeading = element('h3', 'card__heading');
    var innerLink = element('a', 'full-unstyled-link');
    innerLink.href = item.url;
    innerLink.textContent = item.title;
    innerHeading.appendChild(innerLink);
    innerInformation.appendChild(innerHeading);
    innerContent.appendChild(innerInformation);
    if (item.onSale) innerContent.appendChild(buildBadge(item, settings));
    inner.appendChild(innerContent);

    return inner;
  }

  function buildContent(item) {
    var content = element('div', 'card__content');
    var information = element('div', 'card__information');
    var heading = element('h3', 'card__heading h5');
    var link = element('a', 'full-unstyled-link');
    link.href = item.url;
    link.textContent = item.title;
    heading.appendChild(link);
    information.appendChild(heading);

    var cardInformation = element('div', 'card-information');
    if (item.price) cardInformation.appendChild(buildPrice(item));
    information.appendChild(cardInformation);
    content.appendChild(information);

    var quickAdd = element('div', 'quick-add no-js-hidden');
    var cta = element('a', 'quick-add__submit button button--full-width button--secondary');
    cta.href = item.url;
    cta.textContent = 'Choose options';
    cta.setAttribute('aria-label', 'Choose options for ' + item.title);
    quickAdd.appendChild(cta);
    content.appendChild(quickAdd);

    return content;
  }

  function buildListItem(item, options) {
    options = options || {};
    var settings = cardSettings();
    var hasMedia = !!item.image;
    var listItem = element('li', 'grid__item' + (options.listItemClass ? ' ' + options.listItemClass : ''));
    var wrapper = element('div', 'card-wrapper product-card-wrapper underline-links-hover');

    if (options.showWishlist !== false) wrapper.appendChild(buildWishlistButton(item));

    var card = element(
      'div',
      'card card--' + settings.style + (hasMedia ? ' card--media' : ' card--text') + ' card--extend-height'
    );
    card.style.setProperty('--ratio-percent', '100%');
    if (hasMedia) card.appendChild(buildMedia(item, settings));
    var content = buildContent(item);
    // No media: the badge belongs in the outer card__content instead (see
    // buildMedia's comment for why a media card puts it inside card__inner).
    if (!hasMedia && item.onSale) content.appendChild(buildBadge(item, settings));
    card.appendChild(content);
    wrapper.appendChild(card);
    listItem.appendChild(wrapper);
    return listItem;
  }

  // Fetches the *real*, server-rendered card-product markup for a product
  // instead of approximating it here. Every product template renders
  // card-product for itself, hidden (see sections/main-product.liquid) —
  // fetching the product's own page and pulling that node out client-side is
  // the same technique quick-add.js already uses on this theme (it fetches
  // `data-product-url` directly with no section_id). Falls back to null on
  // any failure so callers can use buildListItem instead.
  function fetchRealCard(url) {
    if (!url) return Promise.resolve(null);

    return fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Card fetch failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector('[data-product-card-renderer] product-component');
        return source ? document.importNode(source, true) : null;
      })
      .catch(function () {
        return null;
      });
  }

  window.JmpusProductCard = { buildListItem: buildListItem, fetchRealCard: fetchRealCard };
})();
